
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 48 60"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Layer 2"}},[_c('path',{attrs:{"d":"M24 2.505a21.137 21.137 0 1021.137 21.137A21.16 21.16 0 0024 2.505zm0 40.274a19.137 19.137 0 1119.137-19.137A19.159 19.159 0 0124 42.78z"}}),_c('path',{attrs:{"d":"M25 24.323V13.698a1 1 0 10-2 0v11.063a1 1 0 00.321.734l6.588 6.09a1 1 0 101.358-1.468z"}})])])
          )
        }
      }
    